import { Link } from "react-router-dom";
import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";

function Jumbotron() {
    const {data : {home: {jumbotron : {data}}}} = useGetSettingQuery()

    return ( 
        <div className="hero-area hero-bg" style={{backgroundImage: `url(${data.img_background})`}}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-10 offset-lg-1 text-center">
                        <div className="hero-text">
                            <div className="hero-text-tablecell">
                                <p className="subtitle">{data.txt_subtitle}</p>
                                <h1>{data.txt_name}</h1>
                                <div className="hero-btns">
                                    {data.btn_button1 && <Link to={data.btn_button1.key} className="boxed-btn">{data.btn_button1.value}</Link>}
                                    {data.btn_button2 && <Link to={data.btn_button2.key} className="bordered-btn">{data.btn_button2.value}</Link>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default Jumbotron;